import { defineComponent as _defineComponent } from 'vue'
import {computed, ref} from 'vue';
import {useSimulationStore} from '@/components/calculator/services/SimulationStore';
import {I18NGetter} from '@/services/enumTranslator/I18NGetter';
import {useSimulationCurrency} from '@/components/calculator/useSimulationCurrency';
import {
  ReferenceRateMode,
  useReferenceRate
} from '@/components/calculator/results/userInputPanel/useReferenceRate';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReferenceRatePanel',
  setup(__props) {

const referenceRateTypes: Record<ReferenceRateMode, string> = {
  [ReferenceRateMode.COMMON]: I18NGetter().useMortgageSimulationResults.COMMON_REFERENCE_RATE,
  [ReferenceRateMode.SPLIT]: I18NGetter().useMortgageSimulationResults.SPLIT_REFERENCE_RATE,
};
const store = useSimulationStore();
const {isForeignCurrency,} = useSimulationCurrency();
const {
  selectedReferenceRateType,
  referenceRate,
  referenceRateWibor3m,
  referenceRateWibor6m,
  referenceRateWiron1m,
  setSplitReferenceRate,
  setCommonReferenceRate,
} = useReferenceRate();

const updateSimulation = store.debouncedUpdateSimulation();

const referenceRateInfo = computed<string>(() =>
  selectedReferenceRateType.value === ReferenceRateMode.COMMON
    ? I18NGetter().useMortgageSimulationResults.COMMON_REFERENCE_RATE_INFO
    : I18NGetter().useMortgageSimulationResults.SPLIT_REFERENCE_RATE_INFO);

const onReferenceRateTypeToggle = (value: ReferenceRateMode) => {
  if (value === ReferenceRateMode.COMMON) {
    setCommonReferenceRate();
  } else {
    setSplitReferenceRate();
  }
  const isSomeReferenceRateSet: boolean = Boolean(
    referenceRate.value || referenceRateWibor3m.value || referenceRateWibor6m.value || referenceRateWiron1m.value
  );
  if (isSomeReferenceRateSet) {
    updateSimulation();
  }
};

return { __sfc: true,referenceRateTypes, store, isForeignCurrency, selectedReferenceRateType, referenceRate, referenceRateWibor3m, referenceRateWibor6m, referenceRateWiron1m, setSplitReferenceRate, setCommonReferenceRate, updateSimulation, referenceRateInfo, onReferenceRateTypeToggle, I18NGetter, ReferenceRateMode }
}

})